import type { ReactNode } from "react";
import { Button } from "./Button";
import { describeError } from "./errors";

/** The three things a screen shows instead of its content: still loading, nothing there, failed. */

export function Loading({ label = "불러오는 중입니다" }: { label?: string }) {
  return (
    <p className="state" role="status">
      {label}
    </p>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="state">
      <b>{title}</b>
      {children}
    </div>
  );
}

export function ErrorNote({
  error,
  message,
  onRetry,
  children,
}: {
  error?: unknown;
  message?: string;
  onRetry?: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="state state-error" role="alert">
      <p>{message ?? describeError(error)}</p>
      {onRetry && <Button onClick={onRetry}>다시 시도</Button>}
      {children}
    </div>
  );
}
